export default __webpack_public_path__ + "static/media/visa.053daacb.svg";